<template>
  <audio class="audio" controls="controls" controlsList="nodownload" style="padding: 10px">
    <source :src="src"
            type="audio/ogg">
  </audio>
</template>

<script>
export default {
  props: ['src']
}
</script>

<style>
  audio {
    outline: none;
    min-width: 250px;
    width: 100%;
  }
</style>
